import { render, staticRenderFns } from "./PlaylistSearch.vue?vue&type=template&id=5980e148&"
import script from "./PlaylistSearch.vue?vue&type=script&lang=ts&"
export * from "./PlaylistSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports